// extracted by mini-css-extract-plugin
export var boxItems = "_2j-1";
export var boxItemsLg = "_2j-2";
export var button = "_2j-7";
export var buttonHoverless = "_2j-9";
export var buttonLg = "_2j-8";
export var filterGroupBox = "_2j-0";
export var icon = "_2j-3";
export var iconSecondary = "_2j-6";
export var iconWrapper = "_2j-4";
export var iconWrapperLg = "_2j-5";
export var truncatedLabel = "_2j-a";